export default {
    //ProjectsList
    your_created_projects: "Tus proyectos creados",
    new_project: "Nuevo Curso",
    search_course_placeholder: "Busca tu projecto",
    projects_name: "NOMBRE DEL CURSO",
    update_at: 'Actualizado el ',
    coming_soon: 'Próximamente',
    search_your_project: 'Busca tu curso...',
    project_name: 'Nombre del curso',
    loading_projects: 'Cargando proyectos...',

    //ProjectEditComponent
    modify_project: 'Modificando tu proyecto',
    general: 'General',
    layout: 'Plantilla',
    access: 'Acceso',
    branding: 'Branding',
    product_page: 'Página de Producto',
    sale: 'Venta',
    seo_text: 'SEO',
    product: 'Producto',

    //CategoriesSlideOverComponent
    categories: 'Categorías',
    text_category: 'Clasifica tus productos por categorías, así facilitarás a tus alumnos comprar tus cursos.',
    select_category: 'Selecciona categoría...',
    ebook: 'E-book',
    online_project: 'Curso online',
    blended_learning: 'Curso semi-presencial',
    online_program: 'Programa Online',
    webinar_consulting: 'Webinar / Consultoría online',
    remove_category: 'Eliminar categoría',
    href_help: 'Deseo saber más sobre las categorías',

    //ProjectEdit
        //CustomCategoriesComponent
        //ProjectGeneralComponent
        category: 'Categoría',
        duration: 'Duración',
        featured_product: 'Producto destacado',
        publish_project: 'Publicar Proyecto',
        delete_project: 'Borrar Proyecto',
        warning_delete: '¡Atención!',
        message_delete_project: 'Al eliminar el curso perderás todos sus datos definitivamente.',
        question_delete_project: '¿Seguro que quieres eliminar este curso?',
        delete: 'Eliminar',
        confirmation_delete_project: '(*) Esta casilla es obligatoria para eliminar el curso',
        navigation: 'Navegación',
        navigation_free: 'Libre',
        navigation_secuential: 'Secuencial',
        navigation_without_restriction: 'Sin restricciones. El usuario podrá navegar libremente por el curso (excluyendo los cursos con contenido por goteo)',
        navigation_completed_restriction: 'El alumno tiene que completar cada unidad de aprendizaje antes de continuar con la siguiente. La finalización de las unidades de aprendizaje puede establecerse de diferentes maneras.',
        quest_lesson_complete: '¿Cuando será considerada una lección completada?',
        lesson_complete_at_visit: 'Al ser visitada',
        lesson_at_visit_info: 'Al entrar en una lección se completará automáticamente en el progreso total del curso. (Por defecto)',
        lesson_complete_at_see: 'Al visualizar el contenido completamente',
        lesson_at_see_info: 'Se marcará como completado al visualizar el contenido completamente (video, ebook, podcast)',
        lesson_complete_on_time: 'Al permanecer un tiempo',
        lesson_on_time_info: 'Se completará al estar en cada lección el tiempo indicado (HH:mm)',
        automatic_navigation: 'Navegación automática',
        automatic_navigation_disabled: 'Desactivado',
        automatic_navigation_enabled: 'Activado',
        automatic_navigation_info: 'Al completar el contenido de una lección pasará a la siguiente lección correspondiente.',
        //PageComponent
        principal_page: 'Página principal',
        objects_presentation: 'Presentación y objetos',
        learning_objectives: 'No te olvides de describir brevemente los objetivos de aprendizaje.',
        teaching_staff: 'Metodología y profesorado',
        public: 'Público',
        content: 'Contenido',
        sidebar: 'Barra Lateral',
        //ProductBrandingComponent
        banner: 'Banner',
        upload_banner: 'Sube tu banner',
        banner_format: 'PNG, JPG, GIF hasta 3MB',
        promotional_video: 'Video Promocional',
        video_url: 'URL del video',
        video_info: 'Si tienes un video promocional, coloca aquí la url del video en Youtube o Vimeo.',
        //SellComponent
        price_management: 'Gestión de Precios',
        sell_price: 'Precio de venta',
        tax: 'En €. (-3% tasas)',
        price_offer: 'Precio de Oferta',
        text_configuration: 'Configuración de textos',
        free_text_button: 'Título de botón de compra gratuito',
        text_if_free: 'Este título aparecerá si tu producto es gratuito',
        on_sale: 'En venta',
        sale_info: 'Si está activado tu producto estará a la venta',

        //SeoComponent
        seo_configuration: 'Configuración SEO',
        seo_title: 'Título SEO',
        slug: 'Slug',
        seo_description: 'Descripción SEO',

    //ProjectListComponent
    featured: 'Destacado',
    classroom: 'Aula',
    slug_text: 'slug',
    project: 'proyecto',
    projects: 'proyectos',
    preview: 'Previsualizar',

    //ProjectAccessComponent
    access_project: 'Acceso al curso',
    draft: 'Borrador',
    draft_text: 'Este proyecto no se mostrará en el catálogo y podrá ser editado',
    published: 'Publicado',
    published_text: 'Este proyecto está publicado y los usuarios podrán acceder a él',
    private: 'Privado',
    private_text: 'Este proyecto es privado, los usuarios de este curso se darán de alta manualmente',
    coming_soon_access: 'Próximamente',
    coming_soon_access_text: 'Este proyecto se mostrará en el catálofo de cursos pero no se podrá acceder',
    enrollment_closed: 'Matriculación cerrada',
    enrollment_closed_text: 'Solamente los usuarios matriculados podrán entrar al curso. El curso aparecerá en el catálogo pero no se podrán matricular nuevos usuarios',
    course_expiration: 'Caducidad del curso',
    project_expiration_info: 'Tu curso será accesible en este período de tiempo. Al finalizar se denegará el acceso al curso a los usuarios matriculados.',
    init_date: 'Fecha de Inicio',
    project_delete: 'Borrar',
    init_date_selected: 'Fecha de inicio seleccionada',
    end_date: 'Fecha de Fin',
    date_delete: 'Borrar',
    end_date_selected: 'Fecha de finalización seleccionada',

    //ProjectContentComponent
    new_section: 'Nueva Sección',
    section_title: 'Título de la sección: ',
    create_section: 'Crear sección',
    import_section: 'Importar sección',
    lesson_title: 'Título:',
    new_lesson: 'Nueva lección',

    //AttachProductListComponent
    attached_products: 'Productos Asociados',
    attach_product: 'Adjuntar Producto',
    loading_attached_products: 'Cargando productos asociados...',
    unattach_product: 'Desasociar producto',
    info_unattach_product: 'Al desasociar el producto al proyecto, los alumnos que compren dicho producto no podrán acceder al proyecto.',
    quest_unattach_product: '¿Seguro que quieres desasociar el producto ',
    no_product_attached: 'NO HAY PRODUCTOS ASOCIADOS',

    //AttachProductSlideOverComponent
    attach_product_slide: 'Asociar Producto',
    selected_product: 'Producto seleccionado',
    quest_attach_product: '¿Quieres adjuntar este producto?',

    //ProjectEditContentComponent
    back: 'Volver',
    select_type_content: 'Selecciona el tipo de contenido',
    type_lesson: 'Tipo: ',
    html_editor: 'Editor HTML',
    html_info_text: 'Inserta el código HTML que quieras mostrar en tu lección',
    insert_video_url: 'Inserta la URL del video',
    content_index: 'Índice de contenidos',
    student_list: 'Lista de estudiantes',

    //ProjectLayoutContent
    image: 'Imagen',
    classic_design: 'Aspecto Clásico',

    //Visibilidad staff (FE-001)
    edit_project: 'Editar curso',

    //Listado de proyectos (FE-003)
    empty_projects_title: 'Todavía no hay cursos',
    empty_projects_text: 'Cuando se cree un curso en esta academia aparecerá aquí.',
    export_students: 'Exportar alumnos',
    unexpected_error: 'Ha ocurrido un error inesperado',

    //Contenedor de edición (FE-005)
    loading_project: 'Cargando el curso...',

    //Secciones del contenido (FE-006)
    course_content: 'Contenido del curso',
    section_title_label: 'Título de la sección',
    section_title_placeholder: 'Ej.: Introducción',
    section_title_required: 'El título de la sección es obligatorio',
    section_created: 'Sección creada',
    section_saved: 'Sección guardada',

    //Estados vacíos y lecciones (FE-008)
    empty_sections_title: 'Este curso todavía no tiene contenido',
    empty_sections_text: 'Crea una sección para empezar a organizar las lecciones.',
    empty_lessons: 'Esta sección aún no tiene lecciones.',
    add_lesson: 'Añadir lección',
    lesson_title_label: 'Título de la lección',
    lesson_title_placeholder: 'Ej.: Bienvenida al curso',
    lesson_title_required: 'El título de la lección es obligatorio',
    lesson_created: 'Lección creada',
    edit_lesson_content: 'Editar contenido de la lección',

    //Pantalla de lección (FE-009)
    back_to_content: 'Volver al contenido',
    loading_lesson: 'Cargando la lección...',

    //Cabecera de lección con contexto (FE-053)
    lesson_breadcrumb: 'Posición de la lección en el curso',
    section_n: 'Sección {number}',
    lesson_n_of_total: 'Lección {number} de {total}',
    previous_lesson: 'Anterior',
    next_lesson: 'Siguiente',
    previous_lesson_named: 'Lección anterior: {title}',
    next_lesson_named: 'Lección siguiente: {title}',
    course_outline_short: 'Índice',
    course_outline: 'Índice del curso',
    current_lesson: '(lección actual)',
    rename_lesson_named: 'Renombrar la lección «{title}»',
    view_as_student: 'Ver como alumno',
    opens_in_new_tab: '(se abre en una pestaña nueva)',

    lesson_editing_coming_soon: 'La edición del contenido de las lecciones estará disponible próximamente.',

    //Adjuntar producto (FE-010)
    product_attached: 'Producto asociado al curso',
    product_detached: 'Producto desasociado del curso',

    //Pestaña General (FE-011)
    status_label: 'Estado',
    general_editing_coming_soon: 'La edición de los datos del curso (título, estado, borrado) estará disponible próximamente.',

    //Pestaña Acceso (FE-012)
    enrol_configuration: 'Configuración de matriculación',
    enrol_configuration_empty: 'Haz clic en el botón para crear una configuración de matriculación. Los alumnos iniciarán y finalizarán la matrícula en el curso según esta configuración.',
    enrol_configuration_create: 'Configurar matriculación',
    enrol_time_start: 'Tiempo de inicio',
    enrol_time_end: 'Tiempo de fin',
    enrol_time_value: 'Cantidad',
    enrol_time_unit: 'Unidad de tiempo',
    time_unit_hours: 'Horas',
    time_unit_days: 'Días',
    time_unit_weeks: 'Semanas',
    time_unit_months: 'Meses',
    time_unit_years: 'Años',
    enrol_configuration_invalid_value: 'Los tiempos deben ser números enteros iguales o mayores que 0',
    enrol_configuration_invalid_unit: 'Selecciona una unidad de tiempo válida',
    enrol_configuration_saved: 'Configuración de matriculación guardada',
    enrol_configuration_deleted: 'Configuración de matriculación eliminada',

    //Textos del editor de contenido (FE-013)
    drag_section: 'Arrastrar para reordenar la sección',
    drag_lesson: 'Arrastrar para reordenar la lección',
    delete_section: 'Borrar sección',
    delete_lesson: 'Borrar lección',
    sections_order_saved: 'Orden de secciones guardado',
    sections_order_error: 'Error al guardar el orden de las secciones',
    lessons_order_saved: 'Orden de lecciones guardado',
    lessons_order_error: 'Error al guardar el orden de las lecciones',

    // FE-020 · Borrar secciones y lecciones
    delete_section_title: '¿Borrar la sección «{title}»?',
    delete_section_message: 'La sección se eliminará del curso.',
    delete_section_with_lessons_message: 'La sección contiene {count} lección(es) que también se borrarán. Los alumnos dejarán de verlas.',
    delete_lesson_title: '¿Borrar la lección «{title}»?',
    delete_lesson_message: 'La lección y su contenido se eliminarán del curso.',
    delete_confirm_button: 'Borrar',
    section_deleted: 'Sección borrada',
    lesson_deleted: 'Lección borrada',

    // FE-021 · Renombrar lecciones
    lesson_saved: 'Lección guardada',

    // FE-022 · Reordenar y mover lecciones
    move_section_up: 'Subir sección',
    move_section_down: 'Bajar sección',
    move_lesson_up: 'Subir lección',
    move_lesson_down: 'Bajar lección',
    empty_lessons_drop: 'Esta sección aún no tiene lecciones. Puedes añadir una o arrastrarla aquí desde otra sección.',

    // FE-023 · Publicar y vista previa gratuita
    status_published: 'Publicada',
    status_draft: 'Borrador',
    publish_section: 'Publicar sección',
    unpublish_section: 'Despublicar sección',
    publish_lesson: 'Publicar lección',
    unpublish_lesson: 'Despublicar lección',
    section_published: 'Sección publicada',
    section_unpublished: 'Sección despublicada: los alumnos ya no la ven',
    lesson_published: 'Lección publicada',
    lesson_unpublished: 'Lección despublicada: los alumnos ya no la ven',
    free_preview_badge: 'Vista previa',
    free_preview_enabled: 'La lección es ahora de vista previa gratuita',
    free_preview_disabled: 'La lección ya no es de vista previa gratuita',

    //Editor de lección por bloques (FE-030)
    loading_blocks: 'Cargando el contenido de la lección...',
    drag_block: 'Arrastrar para reordenar el bloque',
    move_block_up: 'Subir bloque',
    move_block_down: 'Bajar bloque',
    delete_block: 'Quitar bloque',
    block_type_not_editable: 'Este tipo de bloque todavía no se puede editar desde aquí.',
    add_block: 'Añadir bloque',
    discard_changes: 'Descartar cambios',
    blocks_load_error: 'No se ha podido cargar el contenido de la lección',
    blocks_saved: 'Contenido de la lección guardado',
    blocks_save_error: 'Error al guardar el contenido de la lección',
    block_type_rich_text: 'Texto',
    block_rich_text_required: 'El bloque de texto no puede estar vacío',

    //Barra de guardado y estados del editor (FE-051)
    empty_blocks_title: 'Esta lección aún no tiene contenido',
    empty_blocks_text: 'Añade un bloque de texto, una página embebida u otro tipo para empezar.',
    add_first_block: 'Añadir el primer bloque',
    blocks_status_dirty: 'Cambios sin guardar',
    blocks_status_saving: 'Guardando...',
    blocks_status_saved_at: 'Guardado a las {time}',
    blocks_status_clean: 'Sin cambios',
    blocks_errors_count: '{count} bloque con errores | {count} bloque con errores | {count} bloques con errores',
    blocks_go_to_first_error: 'Ir al primero',
    save_shortcut_title: 'Guardar ({shortcut})',
    save_shortcut_hint: '{shortcut} para guardar',
    discard_confirm_title: '¿Descartar los cambios?',
    discard_confirm_text: 'La lección volverá a como estaba la última vez que la guardaste.',

    //Guardado en lote del editor de bloques (FE-055)
    blocks_conflict_title: 'Otra persona ha guardado esta lección',
    blocks_conflict_text: 'Tus cambios siguen en pantalla. Si recargas, verás la versión guardada y perderás lo que no has guardado.',
    blocks_conflict_reload: 'Recargar la lección',
    blocks_conflict_keep: 'Seguir editando',
    blocks_conflict_status: 'Otra persona ha guardado esta lección. Recarga para poder guardar.',
    blocks_conflict_fallback: 'Otra persona ha guardado esta lección mientras la editabas.',

    //Insertar y manejar bloques (FE-052)
    block_actions: 'Acciones del bloque',
    block_position: 'Bloque {position} de {total}',
    collapse_block: 'Plegar bloque',
    expand_block: 'Desplegar bloque',
    duplicate_block: 'Duplicar',
    move_block_first: 'Mover al principio',
    move_block_last: 'Mover al final',
    insert_block_after: 'Insertar un bloque después del bloque {position}',
    block_type_rich_text_description: 'Párrafos, títulos, listas, enlaces e imágenes.',
    block_type_embed_description: 'Formularios, documentos o presentaciones de servicios permitidos.',
    block_type_video_description: 'Vídeo de YouTube o Vimeo.',
    block_type_quiz_description: 'Preguntas con corrección automática.',

    //Bloque de página embebida (FE-050)
    block_type_embed: 'Página embebida',
    block_embed_url_invalid: 'Escribe la dirección completa de la página, empezando por https://',
    block_embed_height_invalid: 'El alto debe ser un número entero entre 100 y 3000 píxeles',
    block_embed_domain_not_allowed: 'El dominio {host} no está permitido para incrustar páginas',
    embed_url_label: 'Dirección de la página',
    embed_url_placeholder: 'https://docs.google.com/forms/...',
    embed_url_help: 'Solo páginas https de servicios permitidos, como Google Forms, Google Docs, Microsoft Forms o Slidebean.',
    embed_height_label: 'Alto (píxeles)',
    embed_height_help: 'Entre {min} y {max}. Si lo dejas vacío, se usa el alto por defecto.',
    embed_preview: 'Previsualizar',
    embed_preview_title: 'Vista previa de la página embebida',
    embed_preview_after_save: 'La vista previa aparecerá cuando guardes la lección.',

    //Bloque de imagen (FE-057)
    block_type_image: 'Imagen',
    block_type_image_description: 'Una imagen con texto alternativo y pie opcional.',
    block_image_required: 'Sube una imagen para este bloque',
    block_image_alt_required: 'Escribe el texto alternativo de la imagen',
    block_image_file_invalid: 'La imagen ya no está disponible: sube otra',
    image_choose: 'Elegir imagen',
    image_replace: 'Cambiar imagen',
    image_drop_hint: 'o arrástrala aquí',
    image_file_help: 'JPG, PNG, GIF o WebP. Máximo {max} MB.',
    image_uploading: 'Subiendo imagen... {progress} %',
    image_preview_unavailable: 'No se puede mostrar la vista previa de la imagen.',
    image_type_invalid: 'Formato no admitido: usa JPG, PNG, GIF o WebP',
    image_too_large: 'La imagen pesa más de {max} MB',
    image_upload_throttled: 'Has subido muchas imágenes seguidas. Espera un minuto y vuelve a intentarlo.',
    image_upload_error: 'No se ha podido subir la imagen. Inténtalo de nuevo.',
    image_alt_label: 'Texto alternativo (obligatorio)',
    image_alt_help: 'Describe en una frase lo que muestra la imagen y por qué importa en la lección, por ejemplo «Gráfico de ventas que crece cada trimestre de 2025». No empieces por «Imagen de».',
    image_caption_label: 'Pie de imagen (opcional)',

    //Bloque de archivos descargables (FE-058)
    block_type_file: 'Archivos descargables',
    block_type_file_description: 'Documentos u otros archivos para que el alumno los descargue.',
    block_file_required: 'Sube al menos un archivo para este bloque',
    block_file_too_many: 'Este bloque tiene demasiados archivos: quita alguno',
    block_file_invalid: 'Algún archivo ya no está disponible: quítalo y vuelve a subirlo',
    block_file_name_invalid: 'El nombre visible de un archivo es demasiado largo (máximo 255 caracteres)',
    file_empty: 'Este bloque todavía no tiene archivos.',
    file_list_label: 'Archivos del bloque ({count})',
    file_drag: 'Arrastrar para reordenar el archivo',
    file_open_new_tab: 'se abre en una pestaña nueva',
    file_name_label: 'Nombre visible (opcional)',
    file_move_up: 'Subir archivo',
    file_move_down: 'Bajar archivo',
    file_remove: 'Quitar archivo',
    file_missing: 'Este archivo ya no está disponible. Quítalo del bloque.',
    file_unnamed: 'Archivo sin nombre',
    file_uploading: 'Subiendo... {progress} %',
    file_queued: 'En espera',
    file_retry: 'Reintentar la subida',
    file_dismiss: 'Descartar',
    file_choose: 'Elegir archivos',
    file_add_more: 'Añadir más archivos',
    file_drop_hint: 'o arrástralos aquí',
    file_limit_reached: 'Has llegado al máximo de {max} archivos en este bloque.',
    file_help: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, ZIP, imágenes (JPG, PNG, GIF, WebP) o MP3. Hasta {max} MB por archivo y {count} archivos por bloque.',
    file_type_invalid: 'Formato no admitido',
    file_too_large: 'El archivo pesa más de {max} MB',
    file_too_many: 'No caben más archivos: el máximo es {max} por bloque',
    file_upload_throttled: 'Has subido muchos archivos seguidos. Espera un minuto y vuelve a intentarlo.',
    file_upload_error: 'No se ha podido subir el archivo. Inténtalo de nuevo.',

    //Bloque de vídeo (FE-031)
    block_type_video: 'Vídeo',
    block_video_required: 'Sube un vídeo o pega un enlace de YouTube o Vimeo',
    video_source_label: 'Origen del vídeo',
    video_source_upload: 'Subir vídeo',
    video_source_embed: 'Enlace de YouTube o Vimeo',
    video_uploaded: 'Vídeo subido',
    video_upload_error: 'Error al subir el vídeo',
    video_url_label: 'Enlace del vídeo',
    video_url_placeholder: 'https://www.youtube.com/watch?v=...',
    video_url_help: 'Admite enlaces de YouTube (incluidos Shorts y youtu.be) y de Vimeo.',
    video_preview: 'Previsualizar',
    video_url_unsupported: 'El enlace no es de YouTube ni de Vimeo o no es válido',
    video_url_error: 'No se ha podido comprobar el enlace del vídeo',

    //Editor de quizzes (FE-033)
    block_type_quiz: 'Quiz',
    block_quiz_required: 'Crea el quiz antes de guardar',
    quiz_empty: 'Este bloque todavía no tiene un quiz.',
    quiz_create: 'Crear quiz',
    quiz_default_title: 'Quiz',
    quiz_created: 'Quiz creado. Guarda la lección para mantenerlo en este bloque.',
    quiz_loading: 'Cargando el quiz...',
    quiz_load_error: 'No se ha podido cargar el quiz',
    retry: 'Reintentar',
    quiz_save_error: 'Error al guardar el quiz',
    quiz_settings_saved: 'Ajustes del quiz guardados',
    quiz_title_label: 'Título del quiz',
    quiz_pass_percentage_label: 'Nota mínima para aprobar (%)',
    quiz_max_attempts_label: 'Intentos máximos',
    quiz_unlimited: 'Ilimitados',
    quiz_max_attempts_help: 'Déjalo vacío para permitir intentos ilimitados.',
    quiz_required_to_progress: 'Obligatorio aprobar para avanzar',
    quiz_shuffle: 'Mezclar preguntas y respuestas',
    quiz_save_settings: 'Guardar ajustes',
    quiz_title_required: 'El título del quiz es obligatorio',
    quiz_pass_percentage_invalid: 'La nota mínima debe ser un número entero entre 0 y 100',
    quiz_max_attempts_invalid: 'Los intentos deben ser un número entero mayor que 0',
    quiz_questions_title: 'Preguntas ({count})',
    quiz_no_questions: 'Añade al menos una pregunta.',
    quiz_add_question: 'Añadir pregunta',
    quiz_edit_question: 'Editar pregunta',
    quiz_delete_question: 'Borrar pregunta',
    quiz_delete_question_title: '¿Borrar esta pregunta?',
    quiz_delete_question_text: 'La pregunta y sus respuestas se borrarán del quiz. Esta acción no se puede deshacer.',
    quiz_question_saved: 'Pregunta guardada',
    quiz_question_deleted: 'Pregunta borrada',
    quiz_drag_question: 'Arrastrar para reordenar la pregunta',
    quiz_move_question_up: 'Subir pregunta',
    quiz_move_question_down: 'Bajar pregunta',
    quiz_order_error: 'Error al guardar el orden de las preguntas',
    quiz_remove_block_title: '¿Quitar el bloque de quiz?',
    quiz_remove_block_text: 'Al guardar la lección se borrará el quiz con sus preguntas y los intentos de los alumnos. Hasta que guardes, puedes descartar los cambios para recuperarlo.',
    quiz_orphan_delete_error: 'La lección se ha guardado, pero no se ha podido borrar el quiz de un bloque quitado. Se volverá a intentar la próxima vez que guardes.',
    quiz_statement_label: 'Enunciado',
    quiz_question_type_label: 'Tipo de pregunta',
    quiz_type_single: 'Opción única',
    quiz_type_multiple: 'Opción múltiple',
    quiz_options_label: 'Respuestas',
    quiz_options_help_single: 'Marca la única respuesta correcta.',
    quiz_options_help_multiple: 'Marca todas las respuestas correctas.',
    quiz_correct: 'Correcta',
    quiz_option_text_label: 'Respuesta {number}',
    quiz_option_feedback_label: 'Feedback al elegirla (opcional)',
    quiz_add_option: 'Añadir respuesta',
    quiz_remove_option: 'Quitar respuesta',
    quiz_explanation_label: 'Explicación (opcional)',
    quiz_explanation_help: 'Se muestra al alumno después de responder.',
    quiz_question_type_required: 'Elige el tipo de pregunta',
    quiz_statement_required: 'El enunciado es obligatorio',
    quiz_min_options: 'Añade al menos dos respuestas',
    quiz_option_text_required: 'Todas las respuestas deben tener texto',
    quiz_single_requires_one_correct: 'Marca exactamente una respuesta correcta',
    quiz_multiple_requires_correct: 'Marca al menos una respuesta correcta',

    // FE-040 · Crear curso desde el panel
    new_course: 'Nuevo curso',
    new_course_title: 'Crear un curso',
    new_course_text: 'Se creará en borrador. Después podrás añadir el contenido y completar su ficha.',
    course_title_label: 'Título del curso',
    course_title_placeholder: 'Ej.: Introducción a la fotografía',
    course_title_required: 'El título del curso es obligatorio',
    create_course: 'Crear curso',
    course_created: 'Curso creado',

    // FE-041 · Editar la ficha del curso
    archived: 'Archivado',
    course_details_loading: 'Cargando la ficha del curso...',
    course_subtitle_label: 'Subtítulo',
    course_description_label: 'Descripción',
    course_cover_label: 'Imagen de portada',
    course_cover_alt: 'Portada del curso',
    course_cover_empty: 'Sin portada',
    course_cover_help: 'Imagen en proporción 16:9 (recomendado 1280×720), hasta 5 MB.',
    course_cover_invalid: 'Selecciona una imagen de 5 MB como máximo',
    course_slug_label: 'URL amigable (slug)',
    course_slug_help: 'Solo minúsculas, números y guiones. Si lo dejas vacío se genera a partir del título.',
    course_slug_invalid: 'El slug solo puede contener minúsculas, números y guiones',
    course_saved: 'Ficha del curso guardada',

    // FE-042 · Duplicar y borrar curso
    duplicate_course: 'Duplicar curso',
    course_duplicated: 'Curso duplicado. La copia está en borrador.',
    delete_course: 'Borrar curso',
    delete_course_help: 'El curso dejará de estar disponible para los alumnos. Esta acción no se puede deshacer desde el panel.',
    delete_course_title: '¿Borrar este curso?',
    delete_course_text: 'Se borrarán el curso, sus secciones y sus lecciones. Se conserva el histórico de los alumnos.',
    delete_course_has_students: 'Este curso tiene alumnos matriculados y perderán el acceso. Si quieres continuar, vuelve a confirmar.',
    delete_course_confirmation_label: 'Para confirmar, escribe el nombre del curso:',
    delete_course_force: 'Borrar igualmente',
    course_deleted: 'Curso borrado',

    // ProjectContentComponent · rediseño del editor de contenido
    sections_count: 'Sin secciones | 1 sección | {count} secciones',
    lessons_count: 'Sin lecciones | 1 lección | {count} lecciones',
    create_lesson: 'Crear lección',
    section_number: 'Título de la sección {number}',
    edit_content: 'Editar',
    edit_lesson_content_of: 'Editar el contenido de «{title}»',

    //Secciones plegables con resumen (FE-061)
    expand_all_sections: 'Desplegar todo',
    collapse_all_sections: 'Plegar todo',
    expand_section: 'Desplegar la sección «{title}»',
    collapse_section: 'Plegar la sección «{title}»',
    section_actions: 'Acciones de la sección «{title}»',
    lessons_published_count: 'ninguna publicada | 1 publicada | {count} publicadas',

    //Programación (drip) dentro de la sección (FE-062)
    drip_menu: 'Programación',
    drip_title: 'Programación de la sección',
    drip_help: 'Decide cuándo pueden ver esta sección los alumnos.',
    drip_immediate: 'Disponible desde la matrícula',
    drip_days_option: 'Unos días después de la matrícula',
    drip_days_label: 'Días después de la matrícula',
    drip_days_suffix: 'días después de la matrícula',
    drip_date_option: 'En una fecha fija',
    drip_date_label: 'Fecha a partir de la que está disponible',
    drip_days_invalid: 'Escribe un número entero de días entre {min} y {max}',
    drip_date_invalid: 'Elige una fecha válida',
    drip_saved: 'Programación de la sección guardada',
    drip_badge_days: '{count} días tras la matrícula | 1 día tras la matrícula | {count} días tras la matrícula',
    drip_badge_date: 'Desde el {date}',
    drip_edit_of: 'Editar la programación de «{title}»: {schedule}',

    //Filas de lección simplificadas (FE-063)
    lesson_title_edit_hint: 'Haz clic para renombrar. Enter guarda y Escape deshace.',
    saved_inline: 'Guardado',
    free_preview_enable: 'Activar vista previa gratuita',
    free_preview_enable_help: 'Cualquier visitante podrá ver esta lección sin comprar el curso.',
    free_preview_disable: 'Quitar vista previa gratuita',
    lesson_actions: 'Acciones de la lección «{title}»',

    //Duplicar y acciones en lote (FE-065)
    duplicate_lesson: 'Duplicar',
    duplicate_lesson_help: 'La copia se crea justo debajo, en borrador.',
    duplicate_section: 'Duplicar sección',
    duplicate_section_help: 'Copia la sección con sus lecciones justo debajo, en borrador.',
    lesson_duplicated: 'Lección duplicada',
    section_duplicated: 'Sección duplicada',
    publish_section_with_lessons: 'Publicar sección y lecciones',
    unpublish_section_with_lessons: 'Despublicar sección y lecciones',
    publish_section_with_lessons_title: '¿Publicar «{title}» con sus lecciones?',
    unpublish_section_with_lessons_title: '¿Despublicar «{title}» con sus lecciones?',
    publish_section_with_lessons_message: 'Se publicará la sección. Todas sus lecciones ya están publicadas. | Se publicarán la sección y {count} lección en borrador. Los alumnos podrán verlas. | Se publicarán la sección y {count} lecciones en borrador. Los alumnos podrán verlas.',
    unpublish_section_with_lessons_message: 'Se despublicará la sección. Ninguna de sus lecciones está publicada. | Se despublicarán la sección y {count} lección publicada. Los alumnos dejarán de verlas. | Se despublicarán la sección y {count} lecciones publicadas. Los alumnos dejarán de verlas.',
    section_with_lessons_published: 'Sección y lecciones publicadas',
    section_with_lessons_unpublished: 'Sección y lecciones despublicadas',
    bulk_publish_partial_error: 'No se ha podido cambiar ningún elemento | No se ha podido cambiar {count} elemento: revisa su estado e inténtalo de nuevo. | No se han podido cambiar {count} elementos: revisa su estado e inténtalo de nuevo.',

    //Currículo en móvil (FE-064)
    rename_section: 'Renombrar la sección «{title}»',
    rename_lesson: 'Renombrar la lección «{title}»',
}
